<template>
  <k-editor-form v-if="list_type">
    <template v-slot:left>
      <k-text-field v-model="list_type.name" label="Name"></k-text-field>
      <k-autocomplete label="Upload config" :items="upload_configurations" v-model="list_type.meta.upload_config" item-text="name" item-value="name">
      </k-autocomplete>
    </template>
    <template v-slot:right>
      Fields:
      <json-editor v-model="list_type.fields" v-if="list_type.fields"></json-editor>
    </template>
    <template v-slot:right-buttons>
      <k-btn size="m" flat @click="reset">Reset</k-btn>
      <k-btn size="m" color="success" @click="save(false)">Save</k-btn>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>
    </template>
  </k-editor-form>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
export default {
  props: ['id'],
  components: {
    JsonEditor
  },
  data() {
    var ch = this.$cloudserver.channel((typeof(this.id) == "undefined" ? "cms:list_type:create" : "cms:list_type:" + this.id));
    return {
      ws_channel: ch,
      list_type: this.convert(ch.data),
    };
  },
  watch: {
    'ws_channel.data': {
      handler(val) {
        this.list_type = this.convert(val)
      },
      deep: true
    }
  },
  computed: {
    upload_configurations () {
      var ret = _.filter(this.$store.state.settings, (val, id) => {
        return val.type == "file_upload";
      })
      return ret;
    }
  },
  created() {
    this.ws_channel.join();
  },
  methods: {
    convert (val) {
      return _.cloneDeep(val.list_type);
    },
    reset() {
      console.log(this.ws_channel);
      this.list_type = this.convert(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var send_list_type = _.cloneDeep(this.list_type);
         console.log("Saving", send_list_type);
        this.ws_channel.push("save", {list_type: send_list_type})
          .receive("ok", (msg) => {
            if (typeof(self.id) == "undefined") {
              self.$message.success("List type was created!");
            } else {
              self.$message.success("List type was updated!");
            }
            if(close) this.$root.close_bottom_sheet()
          })
          .receive("error", (msg) => {
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create list type!");
            } else {
              self.$message.warning("Unable to update list type!");
            }
          });
      }
    }
  }
}
</script>
